
define('modules/application/wizard/classes/series',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {

  var series   = _.extend({}, genericElement, {

    Views : {
      titleBar  : genericElement.Views.titleBar.extend({
        template: "application/wizard/sections/series/titleBar",
        tagName : "h3"
      }),

      content   : genericElement.Views.content.extend({
        template: "application/wizard/sections/series/content"
      })
    }

  });

  // Required, return the module for AMD compliance
  return series;

});